import React from 'react';

function ResizeAllDefault({ fill = '#545659', width = 20, height = 20, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.0207 14.2917H15.9998V10.25H14.7498V13.0417H12.0207V14.2917ZM4.02067 9.75004H5.27067V6.95837H7.99984V5.70837H4.02067V9.75004ZM2.9165 16.6667C2.58317 16.6667 2.2915 16.5417 2.0415 16.2917C1.7915 16.0417 1.6665 15.75 1.6665 15.4167V4.58337C1.6665 4.25004 1.7915 3.95837 2.0415 3.70837C2.2915 3.45837 2.58317 3.33337 2.9165 3.33337H17.0832C17.4165 3.33337 17.7082 3.45837 17.9582 3.70837C18.2082 3.95837 18.3332 4.25004 18.3332 4.58337V15.4167C18.3332 15.75 18.2082 16.0417 17.9582 16.2917C17.7082 16.5417 17.4165 16.6667 17.0832 16.6667H2.9165ZM2.9165 15.4167H17.0832V4.58337H2.9165V15.4167Z" fill={fill} />
    </svg>

  );
}

export default ResizeAllDefault;
